"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plug = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Plug = function (_a) {
    var id = _a.id;
    var clipPathId = id ? "Users__clip0__".concat(id) : 'Users__clip0';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("g", { clipPath: "url(#".concat(clipPathId, ")") },
            react_1.default.createElement("path", { fill: "currentColor", d: "M21.2 7.8V9a.6.6 0 01-.6.6H20v2.808a4.798 4.798 0 01-1.404 3.396l-2.34 2.4A3.6 3.6 0 0114 19.2v4.2a.6.6 0 01-.6.6H9.8a.6.6 0 01-.6-.6v-4.2a3.6 3.6 0 01-2.256-1.032l-2.34-2.4a4.8 4.8 0 01-1.404-3.36V9.6h-.6A.6.6 0 012 9V7.8a.6.6 0 01.6-.6h3V.6a.6.6 0 01.6-.6h1.2a.6.6 0 01.6.6v6.6h7.2V.6a.6.6 0 01.6-.6H17a.6.6 0 01.6.6v6.6h3a.6.6 0 01.6.6z" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: clipPathId },
                react_1.default.createElement("path", { fill: "#fff", d: "M0 0H24V24H0z" })))));
};
exports.Plug = Plug;
//# sourceMappingURL=plug.js.map